import "./RecorderError.scss";

import { Col, Row } from "@amzn/stencil-react-components/layout";
import { H3, Text } from "@amzn/stencil-react-components/text";
import { PropsWithChildren } from "react";
import { FormattedMessage } from "react-intl";

const RecorderError = (
  props: PropsWithChildren<{ error: Error }>
): JSX.Element => {
  return (
    <div className="recorder-error_container">
      <Col
        color="white"
        gridGap={"S100"}
        justifyContent="space-between"
        alignItems="center"
        height={"100%"}
      >
        <Col flex={1} justifyContent="space-evenly">
          <H3 color="neutral10" textAlign="center">
            <FormattedMessage id="recordingError-header" />
          </H3>
          <Row justifyContent="space-evenly">
            <Text fontSize={"T300"} lineHeight={"1"} fontWeight={"medium"}>
              <FormattedMessage id="recordingError-because" />
            </Text>
            <ul className="recorder-error_list">
              <li className="recorder-error_list-item">
                <Text fontSize={"T200"}>
                  <FormattedMessage id="recordingError-reason-1" />
                </Text>
              </li>
              <li className="recorder-error_list-item">
                <Text fontSize={"T200"}>
                  <FormattedMessage id="recordingError-reason-2" />
                </Text>
              </li>
              <li className="recorder-error_list-item">
                <Text fontSize={"T200"}>
                  <FormattedMessage id="recordingError-reason-3" />
                </Text>
              </li>
            </ul>
          </Row>
        </Col>
        <Col flex={1} justifyContent="center" width={"75%"}>
          <Text fontSize={"T300"} textAlign="center">
            <FormattedMessage id="recordingError-check-reason" />
          </Text>
        </Col>
      </Col>
    </div>
  );
};

export default RecorderError;
